import React from "react";
import { Modal, Button } from "react-bootstrap";
import { Doughnut } from "react-chartjs-2";
import "./modal.css";
import { Chart, ArcElement, Tooltip } from "chart.js";
import userIcon from "../../../assets/Apps-User-icon.png";
Chart.register(ArcElement);
Chart.register([Tooltip]);

class ViewModal extends React.Component {
  constructor() {
    super();
    this.state = {
      subject: "",
      query: "",
    };
  }
  render() {
    const state = {
      labels: [`CDP Hours Recorded: `, `CDP Hours Remaining: `],
      datasets: [
        {
          label: "Rainfall",
          backgroundColor: ["#46BFBD", "#BC4B4B"],
          data: [
            Math.abs(this.props.viewTotalRecorded),
            Math.ceil(8 - this.props.viewTotalRecorded),
          ],
          hoverOffset: 1,
        },
      ],
    };
    return (
      <Modal {...this.props}>
        <Modal.Header className="modal-header-primary">
          <Modal.Title id="contained-modal-title-lg">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={this.props.onHide}
            >
              <i className="fa fa-close"> </i>
            </button>
            {!this.props.sendEmailStatus ? "Member Snapshot" : "Contact"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!this.props.sendEmailStatus ? (
            <>
              <div className="modal_text">
                <img src={userIcon} className="modal_icon" alt="usericon" />
                <div className="txt">
                  <h3>{this.props.viewUserName}</h3>

                  <h3>{this.props.viewEmail}</h3>

                  <h3>{this.props.viewStatus}</h3>
                </div>
              </div>
              <div className="doughnut">
                <Doughnut
                  data={state}
                  options={{
                    title: {
                      display: true,
                      text: "Average Rainfall per month",
                      fontSize: 10,
                    },
                    legend: {
                      display: true,
                      position: "right",
                    },
                    tooltips: {
                      enabled: false,
                    },
                    maintainAspectRatio: false,
                    responsive: false,
                  }}
                  height={298}
                  width={596}
                />
              </div>
            </>
          ) : (
            <div className="modal-body">
              <div>
                <div className="form-group">
                  <label htmlFor="exampleSelect2">Email</label>
                  <input
                    type="text"
                    className="form-control ng-pristine ng-untouched ng-valid ng-not-empty"
                    // id="inpuName"
                    // ng-model="Email"
                    // placeholder={this.props.viewEmail}
                    value={this.props.viewEmail}
                    readOnly
                    // aria-invalid="false"
                    // style={{}}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleSelect2">Subject</label>
                  <input
                    type="text"
                    className="form-control ng-pristine ng-untouched ng-valid ng-empty"
                    id="inpuName"
                    ng-model="Subject"
                    placeholder="Subject"
                    aria-invalid="false"
                    onChange={(e) => {
                      this.props.updatesubjectEmail(e.target.value);
                    }}
                    style={{}}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleTextarea">Query</label>
                  <textarea
                    className="form-control ng-pristine ng-untouched ng-valid ng-empty"
                    id="Query"
                    rows={4}
                    ng-model="Query"
                    placeholder="Your Query here"
                    aria-invalid="false"
                    onChange={(e) => {
                      this.props.updatequeryEmail(e.target.value);
                    }}
                    style={{}}
                    defaultValue={""}
                  />
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-warning"
                    onClick={this.props.onHide}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={this.props.sendEmail}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          {!this.props.sendEmailStatus ? (
            <Button className="btn btn-warning" onClick={this.props.onHide}>
              Close
            </Button>
          ) : null}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ViewModal;
